import styled from "styled-components";
import { Wrapper } from 'AppReact';

const Footer = styled.tfoot``;

export default Wrapper(Footer)
